import React, { useEffect, useState } from 'react'
import { Animation, Box, Button, Flex, TabFooter } from '../../../styling/GlobalStyles'
import { Input } from '../../../components/Input/Input'
import { CancelBtn } from 'components/Button/CancelBtn'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { IRolesTab } from 'types/roles.interface'
import { IGetWorkScheduleModel } from 'types/api/shiftsApi.interface'
import { IContractShift } from 'types/api/usersApi.interface'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { BodyText, TitleText } from 'styling/Typography'
import { ChipsContainer } from 'components/CheckBox/CheckBox.styled'
import { CheckChip } from 'components/CheckBox/CheckChip'
import { days, shiftChangeTypes } from 'pages/Employees/employeesData'
import { toast } from 'react-toastify'
import { ShiftListItem } from 'pages/Employees/Employees.styled'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'

export const InfoRolesTab = ({ state, setState, handleSubmit }: IRolesTab) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState((prev) => ({ ...prev, name: e.target.value }))
  }
  const [selectedShift, setSelectedShift] = useState<ISelectValue>(null)

  const handleEnter = (e: KeyboardEvent) => {
    if (e.keyCode === 13) {
      handleSubmit()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleEnter)

    return () => {
      window.removeEventListener('keydown', handleEnter)
    }
  })

  const parse = (data: any) => {
    return data.data.map((item) => ({ label: item.name, value: item.id }))
  }

  const parseWorkScheduleModel = (data: any) => {
    return data.data.map((item: IGetWorkScheduleModel) => ({ label: item.name, value: item.id, isWeekModel: item.isWeekModel, restDaysCount: item.restDaysCount, workDaysCount: item.workDaysCount }))
  }

  const handleFreeDays = (d: number) => {
    setState(prev => {
      const freeDays = prev.freeDays ?? []
      const restDaysCount = prev.workScheduleModelId?.restDaysCount ?? 0
      if (freeDays.includes(d)) {
        return { ...prev, freeDays: freeDays.filter(fd => fd !== d) }
      }
      if (restDaysCount >= freeDays.length + 1) {
        return { ...prev, freeDays: [...freeDays, d] }
      }
      return prev
    })
  }


  const addShift = () => {
    if (selectedShift) {
      setState(prev => ({ ...prev, shifts: [...prev.shifts, { shiftId: selectedShift.value, order: prev.shifts.length + 1, shiftName: selectedShift.label }] }))
    }
  }

  const removeShift = (s: IContractShift) => {
    setState(prev => ({ ...prev, shifts: prev.shifts.filter(sh => sh.shiftId !== s.shiftId).map((sh, i) => ({ ...sh, order: (i + 1) })) }))
  }

  const handleVacationDays = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState(prev => ({ ...prev, vacationDays: e.target.valueAsNumber }))

  }
  const handleSelectForShifts = (v: any, n: string) => {
    // TODO: Srediti tipove, ovaj workScheduleModelId nema u selectedContract a mislim  da ga u objektu ima ima, proveriti
    if (n == 'shiftChangeType' && !state.workScheduleModelId?.value) {
      toast.warn('Work schedule model must be selected before selecting shift change type')
      return
    }

    setState(prev => ({ ...prev, [n]: v, shiftChangeInterval: n == 'workScheduleModelId' ? null : prev.shiftChangeInterval }))
  }

  const handleChangeForShifts = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setState((prev) => {
      const copy = { ...prev }
      copy[name] = Number(value)
      return copy
    })
  }

  useFocusFirstInput()

  const parsePolicies = (data: any) => {
    return data.data.map((item: any) => ({ label: item.policyName, value: item.id }))
  }


  return (
    <Animation>
      <Box width='fit-content' >
        <Flex column width={screen.availWidth < 500 ? '100%' : '500px'} gap='1rem' >
          <Input
            type='text'
            labelText='Role title'
            placeholder='Enter title'
            name='name'
            value={state?.name}
            onChange={handleChange}
            invalid={!state.name ? 'true' : ''}
            nomarg
          />
          <Flex gap='1rem' >
            <Input width='150px' name='vacationDays' allowZero placeholder='15' labelText='Vacation Days' type='number' value={state.vacationDays || null} onChange={handleVacationDays} invalid={!String(state.vacationDays)} />
            <HonestSelectAsyncInput
              name='workScheduleModelId'
              labelText='Work Schedule Model'
              onChange={handleSelectForShifts}
              placeholder='Select model'
              link='work-schedule/model'
              parserFunction={parseWorkScheduleModel}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              defaultValue={state.workScheduleModelId?.label || state?.workScheduleModel?.label || state?.workScheduleModel?.name}
              nomarg
            />
          </Flex>
        </Flex>
        <Flex mt='16' column gap='1rem' width={screen.availWidth < 500 ? '100%' : '500px'} >
          <HonestSelectAsyncInput nomarg parserFunction={parsePolicies} defaultValue={state.permissionPolicy?.label} onChange={v => setState(prev => ({ ...prev, permissionPolicy: v }))} labelText='Permission Policy' link='permission-policy/role' name='permissionPolicy' />

          {state.workScheduleModelId?.isWeekModel && <Flex column gap='1rem' >
            <BodyText weight='bold' >Days off</BodyText>
            <ChipsContainer>
              {days.map(d => <CheckChip key={d.value} active={state.freeDays?.includes(d.value)} onClick={() => handleFreeDays(d.value)} text={d.label} />)}
            </ChipsContainer>
          </Flex>}
          <BodyText weight='bold' >Shifts</BodyText>
          <Flex width='100%' gap='2rem' alignEnd >
            <HonestSelectAsyncInput
              name='shift'
              labelText='Shift'
              onChange={v => setSelectedShift(v)}
              placeholder='Select shift'
              link='shifts'
              parserFunction={parse}
              defaultValue={selectedShift?.label}
              nomarg
            />
            <Button orange onClick={addShift}>
              Add
            </Button>
          </Flex>

          <Flex column gap='1rem'  >
            {state.shifts.map(s => <ShiftListItem key={s.order} >
              <Flex width='100%' between ><Flex gap='1rem' ><TitleText weight='bold' >{s.order}</TitleText><BodyText>{s.shiftName}</BodyText></Flex><CloseIcon onClick={() => removeShift(s)} /></Flex>
            </ShiftListItem>)}
          </Flex>
          {state.shifts.length >= 2 && <Flex column gap='1rem' width='100%' >
            <HonestSelectInput name='shiftChangeType' labelText='Shift Change Type' onChange={handleSelectForShifts} options={shiftChangeTypes} defaultValue={state?.shiftChangeType?.value} />
            {state.shiftChangeType?.label == 'Manual' && state?.workScheduleModelId?.label && <Input
              type='number'
              labelText='Shift Change Interval'
              name='shiftChangeInterval'
              value={state.shiftChangeInterval}
              max={state.workScheduleModelId.workDaysCount}
              nomarg
              onChange={handleChangeForShifts}
              placeholder={'Maximum: ' + state.workScheduleModelId?.workDaysCount}
            />}
          </Flex>}
        </Flex>
      </Box>

      <TabFooter>
        <Flex end='true' gap='1em'>
          <CancelBtn />
          <Button orange type='button' onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </TabFooter>
    </Animation>
  )
}
